<template>
  <svg width="13" height="17" viewBox="0 0 13 17" xmlns="http://www.w3.org/2000/svg" :fill="fill">
    <path
      d="M6.25 16.6667C5.79167 16.6667 5.39931 16.5035 5.07292 16.1771C4.74653 15.8507 4.58333 15.4583 4.58333 15H7.91667C7.91667 15.4583 7.75347 15.8507 7.42708 16.1771C7.10069 16.5035 6.70833 16.6667 6.25 16.6667ZM3.75 14.1667C3.51389 14.1667 3.31597 14.0868 3.15625 13.9271C2.99653 13.7674 2.91667 13.5694 2.91667 13.3333C2.91667 13.0972 2.99653 12.8993 3.15625 12.7396C3.31597 12.5799 3.51389 12.5 3.75 12.5H8.75C8.98611 12.5 9.18403 12.5799 9.34375 12.7396C9.50347 12.8993 9.58333 13.0972 9.58333 13.3333C9.58333 13.5694 9.50347 13.7674 9.34375 13.9271C9.18403 14.0868 8.98611 14.1667 8.75 14.1667H3.75ZM3.125 11.6667C2.16667 11.0972 1.40625 10.3333 0.84375 9.375C0.28125 8.41667 0 7.375 0 6.25C0 4.51389 0.607639 3.03819 1.82292 1.82292C3.03819 0.607639 4.51389 0 6.25 0C7.98611 0 9.46181 0.607639 10.6771 1.82292C11.8924 3.03819 12.5 4.51389 12.5 6.25C12.5 7.375 12.2188 8.41667 11.6562 9.375C11.0938 10.3333 10.3333 11.0972 9.375 11.6667H3.125ZM3.625 10H8.875C9.5 9.55556 9.98264 9.00694 10.3229 8.35417C10.6632 7.70139 10.8333 7 10.8333 6.25C10.8333 4.97222 10.3889 3.88889 9.5 3C8.61111 2.11111 7.52778 1.66667 6.25 1.66667C4.97222 1.66667 3.88889 2.11111 3 3C2.11111 3.88889 1.66667 4.97222 1.66667 6.25C1.66667 7 1.83681 7.70139 2.17708 8.35417C2.51736 9.00694 3 9.55556 3.625 10Z"
      :fill="fill"
    />
  </svg>
</template>
<script>
export default {
  name: 'LightBulbIcon',
  props: {
    fill: {
      type: String,
      require: true,
    },
  },
};
</script>
